// extracted by mini-css-extract-plugin
export var container = "index-module--container--TTqRt";
export var according = "index-module--according--1Zmc9";
export var paddingLeft = "index-module--paddingLeft--3Vh1Q";
export var columnSaga = "index-module--columnSaga--2BcJQ";
export var tableSaga = "index-module--tableSaga--6c7BA";
export var tableTdSaga = "index-module--tableTdSaga--3sy5L";
export var imgC = "index-module--img-c---epFq";